<template>
  <div class="row">
    <div class="col-lg-12">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
      <div class="row">
        <div class="col-lg">
          <h4>
            Select Site:
            <br />
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.site"
              @change="filterSite()"
            >
              <el-option
                v-for="option in selects.sites"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg">
          <h4>
            Select Collector:
            <br />
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.collector"
              @change="filterCollector()"
            >
              <el-option
                v-for="option in selects.collectors"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg">
          <h4>
            Select Time:
            <br />
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.time"
            >
              <el-option
                v-for="option in selects.times"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg-4">
          <h4>
            Select Date Range :
            <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              :picker-options="pickerOptions"
              @change="getDate()"
            ></el-date-picker>
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg">
          <!--  Total Sorting of Waste Collection by Collectors Based on The Following Categories-->
          <card type="card-chart">
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b
                  >&nbsp;Total Sorting of Waste Collection by Collectors Based
                  on The Following Categories
                </b>
              </h3>
            </template>
            <!--  -->
            <div class="chart-area">
              <bar-chart
                id="chart-custom"
                v-if="barChart1.loaded"
                :chart-data="barChart1.chartData"
                :extra-options="barChart1.extraOptions"
                :gradient-colors="barChart1.gradientColors"
                :gradient-stops="barChart1.gradientStops"
                :height="245"
              ></bar-chart>
              <div
                class="d-flex justify-content-center spinner"
                v-if="!barChart1.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <!-- Total Overall Incoming Waste Tonnage Received -->
          <card type="card-chart">
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b>&nbsp;Total Overall Incoming Waste Tonnage Received </b>
              </h3>
            </template>
            <!--  -->
            <div class="chart-area">
              <line-chart
                v-if="lineChart1.loaded"
                :chart-data="lineChart1.chartData"
                :gradient-colors="lineChart1.gradientColors"
                :gradient-stops="lineChart1.gradientStops"
                :extra-options="lineChart1.extraOptions"
                :height="300"
              ></line-chart>

              <div
                class="d-flex justify-content-center spinner"
                v-if="!lineChart1.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4">
          <!-- Total Incoming Vehicle by The Following Collectors -->
          <card type="card-chart">
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b>&nbsp;Total Incoming Vehicle by The Following Collectors </b>
              </h3>
            </template>
            <!--  -->
            <div class="chart-area">
              <line-chart
                v-if="lineChart2.loaded"
                :chart-data="lineChart2.chartData"
                :gradient-colors="lineChart2.gradientColors"
                :gradient-stops="lineChart2.gradientStops"
                :extra-options="lineChart2.extraOptions"
                :height="300"
              ></line-chart>

              <div
                class="d-flex justify-content-center spinner"
                v-if="!lineChart2.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4">
          <!-- Total Incoming Trip by The Following Collectors -->
          <card type="card-chart">
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-chart-bar-32 text-info"></i>
                <b>&nbsp;Total Incoming Trip by The Following Collectors </b>
              </h3>
            </template>
            <!--  -->
            <div class="chart-area">
              <line-chart
                v-if="lineChart3.loaded"
                :chart-data="lineChart3.chartData"
                :gradient-colors="lineChart3.gradientColors"
                :gradient-stops="lineChart3.gradientStops"
                :extra-options="lineChart3.extraOptions"
                :height="300"
              ></line-chart>

              <div
                class="d-flex justify-content-center spinner"
                v-if="!lineChart2.loaded"
              >
                <circle-8></circle-8>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from "element-ui";
// import RangeSlider from "vue-range-slider";
// import "vue-range-slider/dist/vue-range-slider.css";
import BaseProgress from "../../components/BaseProgress.vue";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { Circle8 } from "vue-loading-spinner";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  components: {
    LineChart,
    BarChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    // RangeSlider,
    BaseProgress,
    Circle8,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      selects: {
        site: "",
        sites: [
          {
            label: "Site A",
            value: "Site A",
          },
        ],
        collector: "",
        collectors: [
          {
            label: "Collector A",
            value: "Collector A",
          },
        ],
        time: "today",
        times: [
          {
            label: "Today",
            value: "today",
          },
          {
            label: "Daily",
            value: "daily",
          },
          {
            label: "Weekly",
            value: "weekly",
          },
          {
            label: "Monthly",
            value: "monthly",
          },
          {
            label: "Yearly",
            value: "yearly",
          },
        ],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          // {
          //   text: "Last 3 months",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   }
          // },
          {
            text: "Last year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "",
      barChart1: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Bulky Waste",
              fill: true,
              fillColor: "#52de97",
              borderColor: "#52de97",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80],
            },
            {
              label: "Domestic Waste",
              fill: true,
              borderColor: "#fc0",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80],
            },
            {
              label: "Separation at source (SAS)",
              fill: true,
              borderColor: "#3282b8",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [80, 100, 70, 80, 120, 80],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
          "rgba(0, 0, 0, 0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0, 1, 0.4, 0],
      },
      lineChart1: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "In-House",
              fill: true,
              borderColor: "#fc0",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fc0",
              pointBorderColor: "#fc0",
              pointHoverBackgroundColor: "#fc0",
              pointBorderWidth: 1,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              data: [150, 150, 150, 150, 150, 150, 150],
            },
            {
              label: "Contractor",
              borderColor: "#3282b8",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#3282b8",
              pointBorderColor: "#3282b8",
              pointHoverBackgroundColor: "#3282b8",
              pointBorderWidth: 1,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              data: [110, 130, 90, 98, 105, 110, 130],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 204, 0, 0.5)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(50, 130, 184, 0.8)",
          "rgba(50, 130, 184, 0.2)",
          "rgba(50, 130, 184, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0],
        loaded: true,
      },
      lineChart2: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "In-House",
              fill: true,
              borderColor: "#fc0",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fc0",
              pointBorderColor: "#fc0",
              pointHoverBackgroundColor: "#fc0",
              pointBorderWidth: 1,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              data: [150, 150, 150, 150, 150, 150, 150],
            },
            {
              label: "Contractor",
              borderColor: "#3282b8",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#3282b8",
              pointBorderColor: "#3282b8",
              pointHoverBackgroundColor: "#3282b8",
              pointBorderWidth: 1,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              data: [110, 130, 90, 98, 105, 110, 130],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 204, 0, 0.5)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(50, 130, 184, 0.8)",
          "rgba(50, 130, 184, 0.2)",
          "rgba(50, 130, 184, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0],
        loaded: true,
      },
      lineChart3: {
        chartData: {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "In-House",
              fill: true,
              borderColor: "#fc",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fc",
              pointBorderColor: "#fc",
              pointHoverBackgroundColor: "#fc",
              pointBorderWidth: 1,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              data: [150, 150, 150, 150, 150, 150, 150],
            },
            {
              label: "Contractor",
              borderColor: "#3282b8",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#3282b8",
              pointBorderColor: "#3282b8",
              pointHoverBackgroundColor: "#3282b8",
              pointBorderWidth: 1,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              data: [110, 130, 90, 98, 105, 110, 130],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 204, 0, 0.5)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(50, 130, 184, 0.8)",
          "rgba(50, 130, 184, 0.2)",
          "rgba(50, 130, 184, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0],
        loaded: true,
      },
    };
  },
  methods: {
    getsites() {
      this.selects.sites = [];

      this.$http.get(":10001/api/v1/setting/destination").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].DestinationName,
              value: response[i].DestinationCode,
            };

            this.selects.sites.push(obj);
          }

          this.selects.site = this.selects.sites[0].value;
        }
      });
    },
    getcollectors() {
      this.selects.collectors = [];

      this.$http.get(":10001/api/v1/setting/supplier").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].SupplierName,
              value: response[i].SupplierCode,
            };

            this.selects.collectors.push(obj);
          }

          this.selects.collector = this.selects.collectors[0].value;
        }
      });
    },
    getAnalytic() {
      this.isLoading = true;
      this.barChart1.loaded = false;
      this.lineChart1.loaded = false;
      this.lineChart2.loaded = false;
      this.lineChart3.loaded = false;

      if (
        this.selects.site != "" &&
        this.selects.collector != "" &&
        this.selects.time != "" &&
        this.value2 != []
      ) {
        let start = moment(this.value2[0]).format("YYYY-MM-DD");
        let end = moment(this.value2[1]).format("YYYY-MM-DD");

        this.$http
          .get(
            ":10001/api/v1/analytics/graphs?from=" +
              start +
              "&to=" +
              end +
              "&site-id=" +
              this.selects.site +
              "&interval=" +
              this.selects.time +
              "&collector=" +
              this.selects.collector
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);

              let colors = ["#fc0", "#3282b8"];

              let timestamp = [];
              let bulky = [];
              let domestic = [];
              let sas = [];

              for (
                var i = 0;
                i < response.IncomingWasteTonnageByCategory.length;
                i++
              ) {
                timestamp.push(
                  response.IncomingWasteTonnageByCategory[i].Interval
                );
                bulky.push(
                  response.IncomingWasteTonnageByCategory[i].TotalBulkyWeight
                );
                domestic.push(
                  response.IncomingWasteTonnageByCategory[i].TotalDomesticWeight
                );
                sas.push(
                  response.IncomingWasteTonnageByCategory[i].TotalSasWeight
                );
              }

              this.barChart1 = {
                chartData: {
                  labels: timestamp,
                  datasets: [
                    {
                      label: "Bulky Waste",
                      fill: true,
                      backgroundColor: "#52de97",
                      fillColor: "#52de97",
                      borderColor: "#52de97",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      data: bulky,
                    },
                    {
                      label: "Domestic Waste",
                      fill: true,
                      backgroundColor: "#fc0",
                      borderColor: "#fc0",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      data: domestic,
                    },
                    {
                      label: "Separation at source (SAS)",
                      fill: true,
                      fillColor: "#3282b8",
                      backgroundColor: "#3282b8",
                      borderColor: "#3282b8",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      data: sas,
                    },
                  ],
                },
                loaded: true,
                extraOptions: chartConfigs.barChartOptionsGradient,
                gradientColors: [
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                  "rgba(0, 0, 0, 0)",
                ],
                gradientStops: [1, 0.4, 0, 1, 0.4, 0, 1, 0.4, 0],
              };

              // Total Overall incoming waste tonnage received
              let datasets2 = [];
              let timestamp2 = [];
              console.log(response.IncomingWasteTonnageByCollector);
              if (response.IncomingWasteTonnageByCollector == null) {
                this.lineChart1.loaded = true;
              } else {
                for (
                  var i = 0;
                  i < response.IncomingWasteTonnageByCollector.length;
                  i++
                ) {
                  let obj = {};
                  let data = [];
                  for (
                    var j = 0;
                    j < response.IncomingWasteTonnageByCollector[i].Data.length;
                    j++
                  ) {
                    if (i == 0) {
                      timestamp2.push(
                        response.IncomingWasteTonnageByCollector[0].Data[j]
                          .Interval
                      );
                    }

                    data.push(
                      response.IncomingWasteTonnageByCollector[i].Data[j].Value
                    );
                  }
                  obj = {
                    label:
                      response.IncomingWasteTonnageByCollector[i]
                        .ContractorName,
                    fill: true,
                    borderColor: colors[i],
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: colors[i],
                    pointBorderColor: colors[i],
                    pointHoverBackgroundColor: colors[i],
                    pointBorderWidth: 1,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 2,
                    pointRadius: 4,
                    data: data,
                  };
                  datasets2.push(obj);
                }
                console.log(datasets2);
                console.log(timestamp2);

                this.lineChart1 = {
                  chartData: {
                    labels: timestamp2,
                    datasets: datasets2,
                  },
                  extraOptions: chartConfigs.purpleChartOptions,
                  gradientColors: [
                    "rgba(255, 204, 0, 0.5)",
                    "rgba(255, 204, 0, 0.0)",
                    "rgba(255, 204, 0, 0.0)",
                    "rgba(50, 130, 184, 0.8)",
                    "rgba(50, 130, 184, 0.2)",
                    "rgba(50, 130, 184, 0.0)",
                  ],
                  gradientStops: [1, 0.4, 0, 1, 0.4, 0],
                  loaded: true,
                };
              }

              // Total incoming vehicle by the following collectors
              let datasets3 = [];
              let timestamp3 = [];
              if (response.IncomingVehicleByCollector == null) {
                this.lineChart2.loaded = true;
              } else {
                for (
                  var i = 0;
                  i < response.IncomingVehicleByCollector.length;
                  i++
                ) {
                  let obj = {};
                  let data = [];
                  for (
                    var j = 0;
                    j < response.IncomingVehicleByCollector[i].Data.length;
                    j++
                  ) {
                    if (i == 0) {
                      console.log(
                        response.IncomingVehicleByCollector[0].Data[j].Interval
                      );
                      timestamp3.push(
                        response.IncomingVehicleByCollector[0].Data[j].Interval
                      );
                    }

                    data.push(
                      response.IncomingVehicleByCollector[i].Data[j].Value
                    );
                  }
                  obj = {
                    label:
                      response.IncomingVehicleByCollector[i].ContractorName,
                    fill: true,
                    borderColor: colors[i],
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: colors[i],
                    pointBorderColor: colors[i],
                    pointHoverBackgroundColor: colors[i],
                    pointBorderWidth: 1,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 2,
                    pointRadius: 4,
                    data: data,
                  };
                  datasets3.push(obj);
                }

                this.lineChart2 = {
                  chartData: {
                    labels: timestamp3,
                    datasets: datasets3,
                  },
                  extraOptions: chartConfigs.purpleChartOptions,
                  gradientColors: [
                    "rgba(255, 204, 0, 0.5)",
                    "rgba(255, 204, 0, 0.0)",
                    "rgba(255, 204, 0, 0.0)",
                    "rgba(50, 130, 184, 0.8)",
                    "rgba(50, 130, 184, 0.2)",
                    "rgba(50, 130, 184, 0.0)",
                  ],
                  gradientStops: [1, 0.4, 0, 1, 0.4, 0],
                  loaded: true,
                };
              }

              // Total incoming trip by the following collectors
              let datasets4 = [];
              let timestamp4 = [];
              if (response.IncomingTripByCollector == null) {
                this.lineChart3.loaded = true;
              } else {
                for (
                  var i = 0;
                  i < response.IncomingTripByCollector.length;
                  i++
                ) {
                  let obj = {};
                  let data = [];
                  for (
                    var j = 0;
                    j < response.IncomingTripByCollector[i].Data.length;
                    j++
                  ) {
                    if (i == 0) {
                      console.log(
                        response.IncomingTripByCollector[0].Data[j].Interval
                      );
                      timestamp4.push(
                        response.IncomingTripByCollector[0].Data[j].Interval
                      );
                    }

                    data.push(
                      response.IncomingTripByCollector[i].Data[j].Value
                    );
                  }
                  obj = {
                    label: response.IncomingTripByCollector[i].ContractorName,
                    fill: true,
                    borderColor: colors[i],
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: colors[i],
                    pointBorderColor: colors[i],
                    pointHoverBackgroundColor: colors[i],
                    pointBorderWidth: 1,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 2,
                    pointRadius: 4,
                    data: data,
                  };
                  datasets4.push(obj);
                }

                this.lineChart3 = {
                  chartData: {
                    labels: timestamp4,
                    datasets: datasets4,
                  },
                  extraOptions: chartConfigs.purpleChartOptions,
                  gradientColors: [
                    "rgba(255, 204, 0, 0.5)",
                    "rgba(255, 204, 0, 0.0)",
                    "rgba(255, 204, 0, 0.0)",
                    "rgba(50, 130, 184, 0.8)",
                    "rgba(50, 130, 184, 0.2)",
                    "rgba(50, 130, 184, 0.0)",
                  ],
                  gradientStops: [1, 0.4, 0, 1, 0.4, 0],
                  loaded: true,
                };
              }

              if (response.IncomingWasteTonnageByCategory[0].Interval == "") {
                this.barChart1.loaded = true;
              }
            }
          });
        this.isLoading = false;
      }
    },
    // gradientColor(flag) {
    //   console.log("hai");
    //   if (flag == "Bulky Waste") {
    //     var canvas = document.getElementById("chart-custom")
    //     var ctx = canvas.getContext("2d");
    //     var gradient = ctx.createLinearGradient(0, 0, 0, 400);
    //     gradient.addColorStop(0, "rgba(250,174,50,1)");
    //     gradient.addColorStop(1, "rgba(250,174,50,0)");
    //   }
    // },
  },
  created() {
    this.getsites();
    this.getcollectors();
    this.value2 = [moment().startOf("d"), moment().startOf("d")];
  },
  watch: {
    "selects.site"() {
      this.getAnalytic();
    },
    "selects.collector"() {
      this.getAnalytic();
    },
    "selects.time"() {
      this.getAnalytic();
    },
    value2() {
      this.getAnalytic();
    },
  },
};
</script>

<style scoped>
.slider {
  /* overwrite slider styles */
  width: 400px;
}
</style>
